exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bi-filter-select-value :hover svg.common-chevron_right{fill:#fff}", ""]);

// exports
